"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const automerge_1 = require("automerge");
const debug_1 = __importDefault(require("debug"));
const events_1 = require("events");
class AutomergeSync extends events_1.EventEmitter {
    constructor(docId, backend) {
        super();
        this.doc = backend || automerge_1.Backend.init();
        this.docId = docId;
        this._peers = new Map();
        this.log = debug_1.default('bc:AutomergePeers:' + this.docId.slice(0, 5));
    }
    removePeer(id) {
        return this._peers.delete(id);
    }
    hasPeer(id) {
        return this._peers.has(id);
    }
    get peers() {
        return Array.from(this._peers.values());
    }
    getPeer(id) {
        return this._peers.get(id);
    }
    idle() {
        for (let peerId in this._peers) {
            let p = this._peers.get(peerId);
            if (!p.idle)
                return false;
        }
        return true;
    }
    _onmessage(peer) {
        return (msg) => {
            msg = new Uint8Array(msg);
            this._receive(peer, msg);
        };
    }
    addPeer(id, peer) {
        let exists = this._peers.get(id);
        if (exists)
            this.removePeer(id);
        this.log('adding peer', id);
        peer.state = automerge_1.Backend.initSyncState();
        this._peers.set(id, peer);
        // HELLO!
        this.log('sending hello');
        this._updatePeer(peer);
        return this._onmessage(peer);
    }
    change(change) {
        // LOCAL CHANGE
        this.log('in change function');
        const [newBackend, patch, newChange] = automerge_1.Backend.applyLocalChange(this.doc, change);
        this._sendToRenderer(patch);
        this.doc = newBackend;
        this.updatePeers();
        return newChange;
    }
    updatePeers() {
        this.log('updating peers', this.docId, Array.from(this._peers).length);
        this._peers.forEach((peer) => {
            peer.idle = false;
            this._updatePeer(peer);
        });
    }
    _sendToRenderer(patch, changes = []) {
        this.log('emitting patch');
        this.emit('patch', { docId: this.docId, patch, changes });
    }
    _updatePeer(peer) {
        this.log('updating peer', peer.id);
        let [nextSyncState, msg] = automerge_1.Backend.generateSyncMessage(this.doc, peer.state);
        peer.state = nextSyncState;
        this._peers.set(peer.id, peer);
        if (msg) {
            this.log('sending syncMsg len=', msg.length);
            peer.send(msg);
            return true;
        }
        else {
            return false;
        }
    }
    _receive(peer, syncMsg) {
        this.log('got syncMsg len=', syncMsg.length);
        let oldDoc = this.doc;
        let [newDoc, newSyncState, patch] = automerge_1.Backend.receiveSyncMessage(this.doc, peer.state, syncMsg);
        this.doc = newDoc;
        peer.state = newSyncState;
        this._peers.set(peer.id, peer);
        if (patch) {
            let changes = automerge_1.Backend.getChanges(newDoc, automerge_1.Backend.getHeads(oldDoc));
            this._sendToRenderer(patch, changes);
        }
        this.updatePeers();
        return patch;
    }
}
exports.default = AutomergeSync;
//# sourceMappingURL=index.js.map